import Pays from '@/generated/classes/Pays';
export default class PaysExtend extends Pays {
  constructor() {
    super();
  }
}
